import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RecuperacaoPage from './pages/RecuperacaoPage';
import RetencaoPage from './pages/RetencaoPage';
import PlaceholderPage from './pages/PlaceholderPage';
import CalendarPage from './pages/CalendarPage';
import ProspeccaoPage from './pages/ProspeccaoPage';
import CccUsersPage from './pages/CccUsersPage';
import CccDashboardPage from './pages/CccDashboardPage';
import CccAuthenticatedShell from './components/CccAuthenticatedShell';
import CccSPARedirectHandler from './components/CccSPARedirectHandler';

const App: React.FC = () => (
  <>
    <CccSPARedirectHandler />
    <Routes>
      {/* /login — inside CccAuthProvider (main.tsx), outside AppProvider */}
      <Route path="/login" element={<LoginPage />} />
      <Route element={<CccAuthenticatedShell />}>
        <Route index element={<HomePage />} />
        <Route path="dashboard" element={<CccDashboardPage />} />
        <Route path="calendario" element={<CalendarPage />} />
        <Route path="recuperacao" element={<RecuperacaoPage />} />
        <Route path="prospeccao" element={<ProspeccaoPage />} />
        <Route path="retencao" element={<RetencaoPage />} />
        <Route path="resolucao" element={<PlaceholderPage title="Resolução" />} />
        <Route path="utilizadores" element={<CccUsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </>
);

export default App;
